<div class="container-fluid">
    <app-gene-table-selector [showGenomic] = true [showAssembly] = false [showRepseq] = false></app-gene-table-selector>
    <app-gene-browser-panel></app-gene-browser-panel>
</div>

